import { Description } from '@radix-ui/react-toast';
import { styled } from 'styled-components';

// Toast text
export const MessageDescription = styled(Description)`
  font-weight: var(--font-weight-label-regular);
`;
